import gql from 'graphql-tag';

export const NAME =
  'compositions_CaseAssetValidationPanel_setCaseCustomerMutation';

export default gql`
  mutation ${NAME} ($caseId: ID!, $customerId: ID!) {
    setCaseNationalCustomer(
      input: {
        id: $caseId,
        patch: { customerId: $customerId }
      }
    ) {
      case {
        id
        customerTerminalLocation
        customer(useCachedDataForCase: true) {
          ... on Customer {
            id
            name
            type
            city
            state
            billTo
            shipTo
            terminalNumber
          }
        }
        paymentMethod
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseAssetValidationPanel/ValidateAssetModal/withSetCaseCustomerByShipTo/setCaseCustomerMutation.js